export enum LineItemType {
    Department,
    Employee
}
